export default "__VITE_ASSET__CxmQt$CX__"